<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div class="dialog--content" :class="setClass">
      <p>{{ content }}</p>
      <div class="u-extra-small-margin--bottom" v-if="messageType == 'delete'">
        <button class="button" v-on:click.prevent="deleteEvent(true)">{{ $t('yes') }}</button>
        <button class="button gray" v-on:click.prevent="onCloseDialog()">{{ $t('no') }}</button>
      </div>
      <button class="close-button" v-on:click.prevent="onCloseDialog()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunicationDialog",
  props: {
    messageType: {
      type: String,
      default: "default"
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {};
  },

  computed: {
    setClass: function() {
      return "dialog--content-" + this.messageType;
    },
    showDialog: {
      get: function() {
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    }
  },
  methods: {
    onCloseDialog: function() {
      this.showDialog = false;
    },
    deleteEvent: function(value) {
      this.$emit("deleteEntry", value);
      this.onCloseDialog();
    }
  }
};
</script>